<template>
  <div class="km__modules__contactform km__popup">
    <button class="km__button--back" type="button" name="back" @click="closeForm"></button>
    <button class="km__button--close" type="button" name="close" @click="closeForm"></button>
    <div class="km__popup--heading">
      <h2>{{ $t("konf_kontakt") }}</h2>
    </div>
    <div class="km__popup--content">
      <p>{{ $t("kontakt_neu_subTitle") }}</p>
      <div>
        <label class="km__label--text">{{ $t("km_your_request") }}</label>
        <textarea class="km__input--area" :class="{error:hasError('anfrage')}" name="name" rows="4" cols="80"
                  v-model="anfrage"></textarea>
      </div>

      <ul class="km__list--modules">
        <ModuleTextInput v-model="vorname" :text="$t('konf_Vorname')" :error="hasError('vorname')"/>
        <ModuleTextInput v-model="nachname" :text="$t('konf_Nachname')" :error="hasError('nachname')"/>
        <ModuleTextInput v-model="street" :text="$t('Label_Strasse')" optional="true" :error="hasError('street')"/>
        <ModuleTextInput v-model="plz" :text="$t('Label_PLZ')" optional="true" :error="hasError('plz')"/>
        <ModuleTextInput v-model="ort" :text="$t('konf_Ort')" optional="true" :error="hasError('ort')"/>
        <ModuleTextInput v-model="land" :text="$t('konf_Land')" optional="true" :error="hasError('land')"/>
        <ModuleTextInput v-model="email" :text="$t('konf_Email')" :error="hasError('email')"/>

        <li class="km__list__element--modules" :class="{error:hasError('acceptprivacyterms')}">
          <input type="checkbox" v-model="acceptprivacyterms">
          <label class="km__label--text">{{ $t("konf_acceptSavingOfDataHeader") }}</label>
          <p>{{ $t("konf_acceptSavingOfDataParagraph1") }}</p>
          <p>
            {{ $t("km_privacy_legal_prelink") }}
            <a :href="datenschutzLink" target="_blank">{{
                $t("Datenschutzerklaerung")
              }}</a>{{ $t("km_privacy_legal_postlink") }}
          </p>
        </li>
      </ul>
    </div>
    <div class="km__popup--buttons">
      <button class="km__button--standard" @click="closeForm">{{ $t("konf_Close") }}</button>
      <button class="km__button--standard blue" @click="submit">{{ $t("konf_Submit") }}</button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed, Ref, ref} from "vue";
import {useStore} from "vuex";
import ModuleTextInput from "@km/components/popups/ModuleTextInput.vue";
import {getAnfrageData, getContactFormErrors,} from "@km/components/popups/contactFormValidation";
import {sendPostRequest} from "@k/global/axiosFormWrapper";
import {useI18n} from "vue-i18n";
import {displayFadeoutMessageToUser} from "@km/components/popups/MessageToDisplayContainer";
import {LinksToWebsite} from "@k/js/databaseInterfaceClasses";
import {getvaluesFromRefObject} from "@km/mixins/formValidation";
import globalsObject from "@k/js/globalsObject";
import {LOOPTRACKINGEVENTNAMES} from "@k/global/loopTracker";
import {EventVerteiler} from "@k/global/eventVerteiler";

function sendAnfrageEmail(parameters, store, lang) {
  sendPostRequest("/konfigurator_php/actionmodul/sendEmail.php", getAnfrageData(parameters, store, lang))
      .then(() => {
        store.commit("SET_OVERLAY_CLOSED", 'contactform');
        EventVerteiler.broadcast("displayHintEventToBeTranslated", {message:"Kontaktformular_Okay"});
      });
}


const store = useStore();

function closeContactForm() {
  store.commit("SET_OVERLAY_CLOSED", 'contactform');
}

const int = useI18n();
const formdata = {
  errors: ref([]) as Ref<string[]>,
  vorname: ref(""),
  nachname: ref(""),
  street: ref(""),
  plz: ref(''),
  ort: ref(''),
  land: ref(''),
  email: ref(''),
  acceptprivacyterms: ref(false),
  anfrage: ref("")
}
const errors = ref([]) as Ref<string[]>;

function submit() {
  globalsObject.loopTracker.trackBasicEvent(LOOPTRACKINGEVENTNAMES.KONFI_SUBMIT_KONTAKT);
  errors.value = getContactFormErrors(formdata)
  if (errors.value.length === 0) {
    sendAnfrageEmail(getvaluesFromRefObject(formdata), store, int.locale.value);
  }
}


const closeForm = closeContactForm;
const vorname = formdata.vorname;
const nachname = formdata.nachname;
const street = formdata.street;
const plz = formdata.plz;
const ort = formdata.ort;
const land = formdata.land;
const email = formdata.email;
const acceptprivacyterms = formdata.acceptprivacyterms;
const anfrage = formdata.anfrage;
const datenschutzLink = computed(() => store.getters["ModelStore/getLinkToWebsite"](LinksToWebsite.privacyterms));
const hasError = name => errors.value.indexOf(name) > -1;


</script>

<style lang="scss" scoped>
@use "../../scss/settings/config" as config;

.km__modules__contactform {
  z-index: 999;
  overflow-y: scroll;

  .km__list__element--modules {
    margin-bottom: 20px;

    p {
      a {
        color: config.$color-black;
        text-decoration: underline;
      }
    }

    &:last-child {
      .km__label--text {
        display: inline-block;
        margin-left: 5px;
        margin-bottom: 20px;
      }
    }

    &.error {
      .km__label--text {
        color: red;
      }
    }
  }

  .km__label--text {
    margin-bottom: 5px;
  }

  .km__input--area {
    margin-bottom: 20px;
  }
}
</style>
